import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handlePutRequest } from "../../../services/PutTemplate";
import { SetEditFlagAction, SetAuthMatrixFurtherDetailsToNullAction, GetCompanyAccountAuthorizationAction, GetCompanyProductDetailsAction } from "../../../redux/actions/companyAction";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";

function AddEditAuthMatrix({ handleAddEditAuthMatrix, companyId, handleSequential, editable }) {

    const AuthorizationMatrixData = useSelector((state) => state?.companySlice?.companyAuthMatrixDetails);

    const [loading, setloading] = useState(false);
    const [disableBtn, setDisableBtn] = useState(false);

    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [productOptions, setproductOptions] = useState([]);
    const [existingProducts, setExistingProducts] = useState([]);
    const [limitCheck, setLimitCheck] = useState([])
    const [limitConflictMsg, setLimitConflictMsg] = useState("")
    const [alreadyExistMsg, setAlreadyExistMsg] = useState("")

    const dispatch = useDispatch();
    const history = useHistory()

    useEffect(() => {
        handleGetRequest("zbizgateway/lov/lovCompanyProducts/" + companyId).then((res) => {
            setproductOptions(res?.data);
        });
    }, []); // eslint-disable-line

    const editFlag__Store = useSelector((state) => state.companySlice?.editFlag);
    const formData__Store = useSelector((state) => state.companySlice?.companyAuthMatrixDetailsForm);

    useEffect(() => {
        if (editFlag__Store) {
            fillAuthMatrixForm();
        }
    }, [editFlag__Store, formData__Store]); // eslint-disable-line

    const fillAuthMatrixForm = () => {
        const productId = { code: formData__Store?.tblProduct?.productCode, description: formData__Store?.tblProduct?.productName, id: formData__Store?.tblProduct?.productId?.toString(), longText: null, shortText: null };
        formik.setFieldValue("toAmount", formData__Store?.toAmount.toString());
        // formik.setFieldValue("fromAmount", formData__Store?.fromAmount.toString());
        formik.setFieldValue("productId", productId);
    };

    const validationSchema = Yup.object().shape({
        productId: Yup.mixed().required("This field is required."),
        // fromAmount: Yup.number()
        //     .nullable()
        //     .notRequired("This field is not required.")
        //     .when('toAmount', (toAmount, schema) => (
        //         schema.test({
        //             test: function (value) {
        //                 return !((value && toAmount) && value > toAmount);
        //             },
        //             message: 'From Amount must be less than or equal to To Amount',
        //         })
        //     )),
        toAmount: Yup.number()
            .notRequired("This field is not required.").min(10, "Limit per day must be at least 10")
    });


    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            productId: "",
            fromAmount: 10,
            toAmount: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                data["productId"] = data?.productId?.id;

                if (editFlag__Store) {
                    data["authMatrixHeadId"] = formData__Store?.authMatrixHeadId;
                    await handlePutRequest(data, "zbizgateway/nonFin/updateCompanyAuthMatrix");
                    dispatch(SetEditFlagAction(false));
                    dispatch(SetAuthMatrixFurtherDetailsToNullAction());
                    dispatch(GetCompanyAccountAuthorizationAction("zbizgateway/nonFin/getCompanyAuthMatrix/" + companyId));
                } else {
                    data["companyId"] = companyId;
                    const res = await handlePostRequest(data, "zbizgateway/nonFin/saveCompanyAuthMatrix");
                    console.log('res', res)
                    dispatch(GetCompanyAccountAuthorizationAction("zbizgateway/nonFin/getCompanyAuthMatrix/" + companyId));
                    handleAddEditAuthMatrix(res);
                }

                formik.resetForm();
            } catch (error) {
                console.error("An error occurred:", error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleCancel = (e) => {
        e.preventDefault();
        formik.resetForm();
        dispatch(SetEditFlagAction(false));
        dispatch(SetAuthMatrixFurtherDetailsToNullAction());
    };

    const getCompanyProductDetail = async () => {
        await dispatch(GetCompanyProductDetailsAction("zbizgateway/nonFin/getCompanyProduct/" + companyId));
    };

    const companyProductDetail = useSelector((state) => state?.companySlice?.companyProductDetails);

    useEffect(() => {
        getCompanyProductDetail();
    }, []);

    useEffect(() => {
        if (companyProductDetail) {
            const limitCheck = companyProductDetail?.map((product) => {
                return {
                    "productId": product?.tblProduct?.productId,
                    "limit": product?.limitPerDay
                }
            })
            setLimitCheck(limitCheck[0])
        }
    }, [companyProductDetail]);

    useEffect(() => {
        const existingProducts = AuthorizationMatrixData.map((product) => product?.tblProduct?.productId)
        setExistingProducts(existingProducts)
    }, [AuthorizationMatrixData]);

    useEffect(() => {
        const productId = parseInt(formik.values.productId?.id)
        if (editFlag__Store === false) {
            if ((existingProducts.includes(productId) && formik.values.toAmount)) {
                setDisableBtn(true)
                setAlreadyExistMsg("Product already exist!")
            }
            else setAlreadyExistMsg("")
        }
        else {
            const { productId, toAmount } = formik.values;

            if (productId.id && toAmount) {
                if (parseInt(productId.id) === limitCheck?.productId) {
                    if (toAmount && (toAmount > limitCheck?.limit)) {
                        console.log("here")
                        setDisableBtn(true);
                        console.log('toAmount', toAmount)
                        setLimitConflictMsg(`Maximum limit against the selected product reached: ${limitCheck?.limit}`);
                    } else {
                        setDisableBtn(false);
                        setLimitConflictMsg("");
                    }
                }
            }
        }
    }, [formik.values.productId, formik.values.toAmount]);

    // useEffect(() => {
    //     const { productId, toAmount } = formik.values;

    //     if (productId.id && toAmount) {
    //         if (parseInt(productId.id) === limitCheck?.productId) {
    //             if (toAmount && (toAmount > limitCheck?.limit)) {
    //                 console.log("here")
    //                 setDisableBtn(true);
    //                 console.log('toAmount', toAmount)
    //                 setLimitConflictMsg(`Maximum limit against the selected product reached: ${limitCheck?.limit}`);
    //             } else {
    //                 setDisableBtn(false);
    //                 setLimitConflictMsg("");
    //             }
    //         }
    //     }
    // }, [formik.values.productId.id, formik.values.toAmount]);

    useEffect(() => {
        formik.setFieldValue("productId", "")
        formik.setFieldValue("toAmount", "")
    }, []);


    return (

        <div>
            <div className="page_header">
                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d_align">
                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
                        <h3 className="mod_heading">Company Account Authorization Matrix</h3>
                    </div>
                </div>
            </div>


            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2 pos_relative">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="productId" className={classNames({ "p-error": isFormFieldValid("productId") }, "Label__Text")}>
                                    Product<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="productId"
                                    placeholder="Enter Product"
                                    options={productOptions}
                                    optionLabel="description"
                                    name="productId"
                                    value={formik.values.productId}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("productId") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("productId")}
                                {alreadyExistMsg && <small style={{ "color": "red", "padding-left": "5px" }}>{alreadyExistMsg}</small>}
                            </div>
                        </div>
                        {/* <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="fromAmount" className={classNames({ "p-error": isFormFieldValid("fromAmount") }, "Label__Text")}>
                                From Amount
                            </label>
                            <InputText id="fromAmount" placeholder="Enter Amount" name="fromAmount" value={formik.values.fromAmount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("fromAmount") }, "Input__Round")} type="number" readOnly />

                            {getFormErrorMessage("fromAmount")}
                        </div>
                    </div> */}
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="toAmount" className={classNames({ "p-error": isFormFieldValid("toAmount") }, "Label__Text")}>
                                    Transaction Limit
                                </label>
                                <InputText id="toAmount" placeholder="Enter Amount" name="toAmount" value={formik.values.toAmount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("toAmount") }, "input_text")} type="number" />
                                {getFormErrorMessage("toAmount")}
                                {limitConflictMsg && <small style={{ "color": "red", "padding-left": "5px" }}>{limitConflictMsg}</small>}
                            </div>
                        </div>
                    </div>
                    {
                        editable === "view" ? (<div className="overlay_field"></div>) : ""
                    }
                    {editable === "true" ? (
                        <div className="GenerateDown__Btn p-mt-4">
                            {/* <Button label="Cancel" onClick={(e) => handleCancel(e)} className="Btn__Transparent" type="button" />
                   <Button loading={loading} icon={loadingIcon || ""} iconPos="right" label={editFlag__Store ? "Update" : "Add"} className="Btn__Dark" disabled={disableBtn} type="submit" /> */}

                            <Button loading={loading} label={editFlag__Store ? "Update" : "Add"} className="Btn__Transparent" disabled={disableBtn} type="submit" />
                            <Button className="Btn__Dark" label="Cancel" onClick={(e) => handleCancel(e)} />
                        </div>
                    ) : null}
                </form>
            </div>
        </div>
    );
}

export default AddEditAuthMatrix;
